(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_cart-products"] && !Shopify.designMode) return;
  try {
    (function() {
    var DEBOUNCE_MS = 300;
    var pending = {};
    var timers = {};
    var summarySectionIds = null;

    function findSummarySectionIds() {
      if (summarySectionIds !== null) return summarySectionIds;
      summarySectionIds = [];
      document.querySelectorAll('[id^="shopify-section-"]').forEach(function(sec) {
        if (sec.querySelector('.vi-cart-items')) return;
        if (sec.querySelector('[class*="cart-summary"], [class*="cart-total"], [data-cart-total], [data-cart-subtotal]')) {
          summarySectionIds.push(sec.id.replace('shopify-section-', ''));
        }
      });
      return summarySectionIds;
    }

    function formatMoneyCLP(cents) {
      return '$' + Math.round(cents / 100).toLocaleString('es-CL') + ' CLP';
    }

    function setLoading(row, on) {
      if (!row) return;
      row.classList.toggle('is-loading', !!on);
    }

    function updateOptimisticTotal(row, newQty) {
      var input = row.querySelector('.vi-cart-items__qty-input');
      var lineTotal = row.querySelector('[data-line-total]');
      if (!input || !lineTotal) return;
      var unit = parseFloat(input.dataset.unitPrice);
      if (isNaN(unit)) return;
      var totalCents = Math.round(unit * newQty);
      lineTotal.textContent = formatMoneyCLP(totalCents);
    }

    function updateCartBadge(cart) {
      document.querySelectorAll('.vi-header__cart-count, [data-cart-count]').forEach(function(b) {
        b.textContent = cart.item_count || '';
      });
    }

    function refreshSummarySections(sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function(sid) {
        var target = document.getElementById('shopify-section-' + sid);
        if (!target) return;
        var wrapper = document.createElement('div');
        wrapper.innerHTML = sections[sid];
        var incoming = wrapper.querySelector('#shopify-section-' + sid);
        if (incoming) {
          target.innerHTML = incoming.innerHTML;
        }
      });
    }

    function scheduleUpdate(key, quantity, row) {
      pending[key] = { quantity: quantity, row: row };
      if (timers[key]) clearTimeout(timers[key]);
      timers[key] = setTimeout(function() {
        var p = pending[key];
        delete pending[key];
        delete timers[key];
        sendUpdate(key, p.quantity, p.row);
      }, DEBOUNCE_MS);
    }

    function sendUpdate(key, quantity, row) {
      var payload = { id: String(key), quantity: quantity };
      var ids = findSummarySectionIds();
      if (ids.length) {
        payload.sections = ids.join(',');
        payload.sections_url = window.location.pathname;
      }
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (cart.item_count === 0) {
          window.location.reload();
          return;
        }
        if (quantity === 0 && row) {
          row.remove();
        } else if (row) {
          var input = row.querySelector('.vi-cart-items__qty-input');
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].key === key) {
              if (input) input.value = cart.items[i].quantity;
              var lt = row.querySelector('[data-line-total]');
              if (lt) lt.textContent = formatMoneyCLP(cart.items[i].final_line_price);
              break;
            }
          }
        }
        updateCartBadge(cart);
        refreshSummarySections(cart.sections);
        setLoading(row, false);
        document.dispatchEvent(new CustomEvent('vi:cart:updated', { detail: cart }));
      })
      .catch(function() { setLoading(row, false); });
    }

    function bind(container) {
      if (container.dataset.viBound === '1') return;
      container.dataset.viBound = '1';

      container.addEventListener('click', function(e) {
        var qtyBtn = e.target.closest('.vi-cart-items__qty-btn');
        var removeBtn = e.target.closest('.vi-cart-items__remove');
        if (!qtyBtn && !removeBtn) return;
        e.preventDefault();

        var row = e.target.closest('.vi-cart-items__row');
        if (!row) return;
        var key = row.dataset.key;

        if (removeBtn) {
          setLoading(row, true);
          scheduleUpdate(key, 0, row);
          return;
        }

        var input = row.querySelector('.vi-cart-items__qty-input');
        var current = parseInt(input.value, 10) || 1;
        var next = qtyBtn.dataset.action === 'plus' ? current + 1 : Math.max(0, current - 1);
        input.value = next;
        updateOptimisticTotal(row, next);
        setLoading(row, true);
        scheduleUpdate(key, next, row);
      });

      container.addEventListener('change', function(e) {
        var input = e.target.closest('.vi-cart-items__qty-input');
        if (!input) return;
        var qty = parseInt(input.value, 10);
        if (isNaN(qty) || qty < 0) qty = 0;
        input.value = qty;
        var row = input.closest('.vi-cart-items__row');
        updateOptimisticTotal(row, qty);
        setLoading(row, true);
        scheduleUpdate(input.dataset.key, qty, row);
      });
    }

    function init() {
      document.querySelectorAll('.vi-cart-items').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
